import React, { useState, useEffect } from 'react'
import { get, patch } from 'aws-amplify/api'
import { useAuth0 } from '@auth0/auth0-react'

import BirthFormContext from '../context/BirthFormContext'
import fullNameSplit from '../utils/fullNameSplit'

const BirthFormProvider = ({ children }) => {
  const { getIdTokenClaims } = useAuth0()
  const [tokenAuth, setTokenAuth] = useState('')
  const [showLoader, setShowLoader] = useState(true)
  const [data, setData] = useState(null)
  const [questions, setQuestions] = useState(null)
  const [template, setTemplate] = useState(null)
  const baseUrl = process.env.REACT_APP_API_BASE_URL
  const [formResults, setFormResults] = useState([
    {
      baby_name: '',
      pregnancy_type: '',
      newborn_sex: '',
      newborn_weight: 0,
      newborn_weight_measure: 'kg'
    }
  ])

  const [congratsView, setCongratsView] = useState(false)
  const [congratsImages, setCongratsImages] = useState([])

  const saveDataBorns = async (allResponses) => {
    setShowLoader(true)
    const { multiple, newBorns } = allResponses
    const year = `${allResponses.birth_date.getFullYear()}`
    const month = `${allResponses.birth_date.getMonth() + 1}`
    const day = `${allResponses.birth_date.getDate()}`

    try {
      const resp = patch({
        apiName: baseUrl,
        path: '/health/newbornRegistry',
        options: {
          headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${tokenAuth.__raw}`
          },
          body: {
            multiple,
            birth_date: [year, month, day],
            new_borns: newBorns
          }
        }
      })
      const { body } = await resp.response
      const data = await body.json()
      if (data.success) {
        setShowLoader(false)
        setCongratsView(true)
        setCongratsImages(data.data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const getBabyNames = () => {
    const names = formResults.map(
      (baby) => fullNameSplit(baby.baby_name).firstName
    )
    switch (names.length) {
      case 1:
        return names[0]
      case 2:
        return names.join(' y ')
      default: {
        names.splice(names.length - 1, 0, 'y ')
        const namesJoin = names.join(', ')
        const splitNames = namesJoin.split(', y , ')
        splitNames.splice(splitNames.length - 1, 0, 'y')

        return splitNames.join(' ')
      }
    }
  }

  useEffect(() => {
    getIdTokenClaims()
      .then((resp) => {
        if (resp !== undefined) {
          setTokenAuth(resp)
        }
      })
      .catch((error) => console.log(error))
  }, [getIdTokenClaims])

  useEffect(() => {
    setShowLoader(true)
    if (tokenAuth !== '') {
      const fetchData = async () => {
        try {
          const resp = get({
            apiName: baseUrl,
            path: '/health/newbornRegistry',
            options: {
              headers: {
                'content-type': 'application/json',
                Authorization: `Bearer ${tokenAuth.__raw}`
              }
            }
          })
          const { body } = await resp.response
          const data = await body.json()
          setData(data.data)
        } catch (error) {
          console.log(error)
        }
      }
      fetchData()
    }
  }, [tokenAuth, baseUrl])

  return (
    <BirthFormContext.Provider
      value={{
        data,
        setData,
        showLoader,
        setShowLoader,
        questions,
        setQuestions,
        template,
        setTemplate,
        formResults,
        setFormResults,
        saveDataBorns,
        congratsView,
        congratsImages,
        getBabyNames
      }}
    >
      {children}
    </BirthFormContext.Provider>
  )
}

export default BirthFormProvider
